import api from "@/lib/api";

// Best-effort behaviour tracking. Only fires for logged-in users; never throws.
export const track = (event_type, data = {}) => {
  try {
    if (!localStorage.getItem("gf_token")) return;
    api.post("/events", { event_type, ...data }).catch(() => {});
  } catch {
    /* noop */
  }
};
